import { render, staticRenderFns } from "./GenMem.vue?vue&type=template&id=e166b5d4&scoped=true"
import script from "./GenMem.vue?vue&type=script&lang=js"
export * from "./GenMem.vue?vue&type=script&lang=js"
import style0 from "./GenMem.vue?vue&type=style&index=0&id=e166b5d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e166b5d4",
  null
  
)

export default component.exports